import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip,
  ResponsiveContainer, CartesianGrid, Legend
} from 'recharts';
import { Typography, Card, CardContent } from '@material-ui/core';

const TrendChart = ({
  data,
  dataKey,
  color = '#1976d2',
  title,
  series,
  formatValue = (v) => v
}) => {
  // Support multi-séries ou single série (rétrocompatibilité)
  const seriesConfig = series || [{ dataKey, color, name: title }];

  return (
    <Card style={{ height: '100%' }}>
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          {title}
        </Typography>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tickFormatter={(date) => new Date(date).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' })}
            />
            <YAxis tickFormatter={formatValue} width={80} />
            <Tooltip
              labelFormatter={(date) => new Date(date).toLocaleDateString('fr-FR')}
              formatter={(value) => formatValue(value)}
            />
            {series && <Legend />}
            {seriesConfig.map((s) => (
              <Line
                key={s.dataKey}
                type="monotone"
                dataKey={s.dataKey}
                stroke={s.color}
                name={s.name}
                strokeWidth={2}
                dot={{ r: 3 }}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default TrendChart;
